module.exports = __webpack_public_path__ + "img/top.e5b6bc46.jpg";